// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__317aS","actions":"GroupTable_actions__1gtJz","deleteModalFooter":"GroupTable_deleteModalFooter__1Fb5T"};